import imageCompression from "browser-image-compression";
import heic2any from "heic2any";

const moment = require("moment-timezone");

function getMonthName(monthNumber) {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return monthNames[monthNumber];
}

function getDateParts(date) {
  let momentInGMT2 = moment.tz(date, "Europe/Zurich");
  let estDate = momentInGMT2.clone().tz("America/New_York");

  let year = String(estDate.year() - 2000).padStart(2, "0");
  let month = getMonthName(estDate.month()).padEnd(3, " ");
  let day = String(estDate.date()).padStart(2, "0");
  let hours = String(estDate.hour());
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  hours = String(hours);
  let minutes = String(estDate.minute()).padStart(2, "0");

  return [year, month, day, hours, minutes, ampm];
}

function buildDateString(date) {
  const [year, month, day, hours, minutes, ampm] = getDateParts(date);

  return `'${year}, ${month} ${day} @ ${hours}:${minutes} ${ampm}`;
}

function buildDateStringElement(date) {
  const [year, month, day, hours, minutes, ampm] = getDateParts(date);

  return (
    <div className="fixed-width-container">
      <span className="date">
        '{year}, {month} {day}
      </span>
      <span className="at"> @ </span>
      <span className="time">
        {hours}:{minutes}
      </span>
      <span className="ampm">{ampm}</span>
    </div>
  );
}

function aggregateRankings(rankings) {
  const points = rankings.reduce((acc, ranking) => {
    Object.entries(ranking).forEach(([position, option]) => {
      acc[option] = (acc[option] || 0) + parseInt(position);
    });
    return acc;
  }, {});

  return Object.entries(points)
    .sort((a, b) => a[1] - b[1] || a[0].localeCompare(b[0])) // this line sorts by points, and handles ties alphabetically
    .map((item, index) => ({
      rank: index + 1,
      option: item[0],
      points: item[1],
    }));
}

async function compressImage(file, maxSizeMB = 1, maxWidthOrHeight = 1920) {
  let processableFile = file;
  const fileType = file.type.toLowerCase();
  const fileName = file.name.toLowerCase();

  if (
    fileType === "image/heic" ||
    fileType === "image/heif" ||
    fileName.endsWith(".heic") ||
    fileName.endsWith(".heif")
  ) {
    const convertedBlob = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.9,
    });
    processableFile = new File([convertedBlob], "temp.jpg", {
      type: "image/jpeg",
    });
  }

  const compressedBlob = await imageCompression(processableFile, {
    maxSizeMB,
    maxWidthOrHeight,
    useWebWorker: true,
    fileType: "image/jpeg",
  });

  return new File([compressedBlob], `photo-${crypto.randomUUID()}.jpg`, {
    type: "image/jpeg",
    lastModified: Date.now(),
  });
}

export function withTimeout(promise, timeoutMs = 5000) {
  const timeout = new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error(`Operation timed out after ${timeoutMs}ms`));
    }, timeoutMs);
  });

  return Promise.race([promise, timeout]);
}

export {
  buildDateString,
  buildDateStringElement,
  aggregateRankings,
  compressImage,
};
